import React from 'react';
import RecipesItems from './RecipesItems';

const Recipes=(props)=> {
    const {recipes}=props;

    return (
        <div className="row">
            { recipes !==[]&&
                recipes.map(recipe =><RecipesItems 
                   key={recipe.recipe.url}
                    label={recipe.recipe.label}
                    image={recipe.recipe.image}
                    ingredientLines={recipe.recipe.ingredientLines}
                    url={recipe.recipe.url}
                    
                    dietLabels={recipe.recipe.dietLabels}
                    cautions={recipe.recipe.cautions}


                        
                    />
                   
                    
                )
                };
        
            
        </div>
    );
};

export default Recipes;